export default "__VITE_ASSET__BkcxYDzR__"